import React, { useMemo } from 'react'
import classnames from 'classnames'
import { useSelector } from 'react-redux'

import PageSection from '../../../../features/components/PageSection'

import { useSroiFilters } from '../SroiFiltersContext'
import { useSroiReportCurrencySymbol } from '../hooks'
import { formatNumberToShort } from '../../helpers'
import { getCategoricalLabels } from '../SroiGraphs/RedesignedSroiGraphs/SocialValueByStakeholders/socialValueByStakeholdersHelpers'

import {
  CATEGORICAL_IMPACT,
  REGIONAL_IMPACT,
  REGION_NAME,
  TOTAL_IMPACT,
  STAKEHOLDER_COUNT
} from '../SroiGraphs/RedesignedSroiGraphs/fields'

import { socialReturnOnInvestmentReportSelector } from '../../../../modules/selectors/socialReturnOnInvestment'

import useStyles from './styles'

export const TotalsSummaryPanels = () => {
  const classes = useStyles()
  const { selectedRegion, selectedStakeholder } = useSroiFilters()
  const report = useSelector(socialReturnOnInvestmentReportSelector)
  const currencySymbol = useSroiReportCurrencySymbol()

  const summaryData = useMemo(() => {
    let data = null

    if (selectedStakeholder) {
      // Get data from categorical_impact based on stakeholder filter
      const categoricalImpact = report?.[CATEGORICAL_IMPACT] || []
      const labels = getCategoricalLabels(categoricalImpact)
      const selectedIndex = labels.findIndex(label => label === selectedStakeholder)

      if (selectedIndex !== -1) {
        data = categoricalImpact[selectedIndex]
      }
    } else if (selectedRegion) {
      // Get data from regional_impact based on region filter
      data = report?.[REGIONAL_IMPACT]?.find(
        region => region[REGION_NAME]?.toLowerCase() === selectedRegion.toLowerCase()
      )
    }

    return {
      totalImpact: data?.[TOTAL_IMPACT] || 0,
      stakeholderCount: data?.[STAKEHOLDER_COUNT] || 0
    }
  }, [report, selectedRegion, selectedStakeholder])

  if (!selectedRegion && !selectedStakeholder) {
    return null
  }

  return (
    <div className={classes.container}>
      <PageSection className={classnames(classes.panel, classes.totalPanel)}>
        Total Impact: {currencySymbol} {formatNumberToShort(summaryData.totalImpact)}
      </PageSection>
      <PageSection className={classnames(classes.panel)}>
        Stakeholders: {formatNumberToShort(summaryData.stakeholderCount)}
      </PageSection>
    </div>
  )
}

export default TotalsSummaryPanels
